import { BasicDetails } from '../interfaces';
import { basicDetailsSlice } from '../reducers/basicDetailsSlice';
import { getStore } from '../store';

/* 
NOTE: we will be using the following naming conventions for defineing actions

1. in case of the whole object being changed: it should start as a SETTER i.e., setBasicDetails
2. in case of a particular key being updated in the object: it should start as an UPDATE function i.e., updateUserSessionActive
*/

type basicDetailsActionType =
  | 'basicDetails/setBasicDetails'
  | 'basicDetails/updateUserSessionActive'
  | 'basicDetails/updateIsUserInactive';

export const basicDetailsProvider = (): {
  setBasicDetails: (basicDetails: BasicDetails) => {
    payload: BasicDetails;
    type: basicDetailsActionType;
  };
  updateUserSessionActive: (isActive: boolean) => {
    payload: boolean;
    type: basicDetailsActionType;
  };
  updateIsUserInactive: (isUserInactive: boolean) => {
    payload: boolean;
    type: basicDetailsActionType;
  };
} => {
  const { dispatch } = getStore();
  const { setBasicDetails, updateUserSessionActive, updateIsUserInactive } = basicDetailsSlice.actions;

  return {
    setBasicDetails: (
      basicDetails: BasicDetails,
    ): {
      payload: BasicDetails;
      type: basicDetailsActionType;
    } => dispatch(setBasicDetails(basicDetails)),
    updateUserSessionActive: (
      isActive: boolean,
    ): {
      payload: boolean;
      type: basicDetailsActionType;
    } => dispatch(updateUserSessionActive(isActive)),
    updateIsUserInactive: (
      isUserInactive: boolean,
    ): {
      payload: boolean;
      type: basicDetailsActionType;
    } => dispatch(updateIsUserInactive(isUserInactive)),
  };
};
